import { ref, watchEffect } from "vue";

const token_key = "token";

const isClient = typeof window !== "undefined";
let token = ref<string | null>(
  isClient ? localStorage.getItem(token_key) : null
);

export function useToken() {
  const getToken = (): string | null | undefined => {
    if (token_key) return isClient ? localStorage.getItem(token_key) : null;
  };

  const setToken = (t: string): void => {
    token.value = t;
    if (token_key) return localStorage.setItem(token_key, t);
  };

  const removeToken = (): void => {
    token.value = null;
    if (token_key) return localStorage.removeItem(token_key);
  };

  const isAuthenticated = ref(false);
  watchEffect(() => {
    isAuthenticated.value = !!token.value;
  });

  // Explicit return type to help IDEs recognize the structure
  return { getToken, setToken, removeToken, isAuthenticated };
}
